const MODULE = {
  state: {
    HMWs: []
  },

  mutations: {
    setHMWs (state, HMWs) {
      state.HMWs = HMWs
    }
  },

  actions: {
    requestAllHMWs: async (context) => {
      if (context.rootState.challenge.currentlyViewedChallenge !== null) {
        // gets and sets all thoughts for the activated challenge
        const endpoint = '/api/v1/hmw'
        const queryParams = {
          challenge: context.rootState.challenge.currentlyViewedChallenge.uuid
        }

        const allHMWs = await context.dispatch('authorizedFetch', {
          method: 'GET',
          endpoint: endpoint,
          queryParams: queryParams
        }, { root: true })

        context.commit('setHMWs', allHMWs.hmws)
      }
    },

    requestCreateHMW: async (context, text) => {
      const endpoint = '/api/v1/hmw'
      const body = {
        challenge: context.rootState.challenge.currentlyViewedChallenge.uuid,
        content: text
      }

      await context.dispatch('authorizedFetch', {
        method: 'POST',
        endpoint: endpoint,
        body: body
      }, { root: true })
    }
  }
}

export default MODULE
